import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ArchiveEntityClient, ArchiveEntityOptionView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ArchiveEntityService {
    constructor(private readonly client: ArchiveEntityClient) {}

    async getArchiveOptions(): Promise<ArchiveEntityOptionView[]> {
        return await lastValueFrom(this.client.archiveEntityGetArchiveOptions());
    }
}
